import {
  ButtonGroup,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import { getUser } from "../../../Utils/externalFunctions";
import { admins } from "../../../Constant";
import { getDarkDropdown } from "../../../Utils/otherFunctions";
import { useThemeContext } from "../../../Context/ThemeContext";
import { Trash2 } from "react-feather";

const TandaTerimaSubHeaderComponent = ({
  handleStatusChange,
  handleCetak,
  toggleDeleteModal,
}) => {
  const { themeContext } = useThemeContext();

  return (
    <Row>
      <Col>
        <ButtonGroup>
          <UncontrolledDropdown>
            <DropdownToggle caret>Aksi</DropdownToggle>
            <DropdownMenu>
              {admins.includes(getUser()) ? (
                <>
                  <DropdownItem
                    className={getDarkDropdown(themeContext)}
                    onClick={() => handleStatusChange(2)}
                  >
                    Terima
                  </DropdownItem>
                  <DropdownItem
                    className={getDarkDropdown(themeContext)}
                    onClick={() => handleStatusChange(3)}
                  >
                    Tolak
                  </DropdownItem>
                  <DropdownItem
                    className={getDarkDropdown(themeContext)}
                    onClick={() => handleStatusChange(4)}
                  >
                    Kembalikan
                  </DropdownItem>
                  <DropdownItem divider />
                </>
              ) : null}
              <DropdownItem
                className={`d-flex align-items-center gap-2 text-danger ${getDarkDropdown(
                  themeContext
                )}`}
                onClick={toggleDeleteModal}
              >
                <Trash2 size={12} />
                Hapus
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </ButtonGroup>
      </Col>
      {/* <Col>
        <Button onClick={handleCetak}>Cetak</Button>
      </Col> */}
    </Row>
  );
};

export default TandaTerimaSubHeaderComponent;
